module.exports = "/cyber/_next/static/images/candy-cane-29cff18b3d7614ee6c76ca1c38cd9003.png";